import { useQuery, useMutation } from "@tanstack/react-query";
import clientPortalAxiosInstance from "../common/utilities/axios/clientPortalAxiosInstance";
import adminAxiosInstance from "../common/utilities/axios/adminAxiosInstance";
import sleep from "sleep-promise";
import clientPortalAxiosInstanceForFileDownLoad from "../common/utilities/axios/clientPortalAxiosInstanceForFileDownLoad";
import apiAxiosInstance from "../common/utilities/axios/apiAxiosInstance";
import sitecoreAxiosInstance from "../common/utilities/axios/sitecoreAxiosInstance";
import environment from "../../common/environments/environment";

/** All Queries */
export const useGetLanguageListQuery = () => {
  return useQuery({
    queryKey: ["getLanguageListQuery"],
    queryFn: () => {
      return clientPortalAxiosInstance
        .get(`/User-Profile/getlanguages`)
        .then((res) => res.data);
    },
  });
};

export const useGetCurrencyListQuery = () => {
  return useQuery({
    queryKey: ["getCurrencyListQuery"],
    queryFn: () => {
      return clientPortalAxiosInstance
        .get(`/User-Profile/getcurrency`)
        .then((res) => res.data);
    },
  });
};

export const useGetClientTypeClassificationQuery = () => {
  return useQuery({
    queryKey: ["getClientTypeClassificationQuery"],
    queryFn: () => {
      return clientPortalAxiosInstance
        .get(`/User-Profile/getClientTypeClassification`)
        .then((res) => res.data);
    },
  });
};

export const useGetTimezonesListQuery = () => {
  return useQuery({
    queryKey: ["getTimezonesList"],
    queryFn: () => {
      return clientPortalAxiosInstance
        .get(`/User-Profile/alltimeszones`)
        .then((res) => res.data);
    },
  });
};
export const useGetAdminRoleListQuery = () => {
  return useQuery({
    queryKey: ["getAdminRoleListQuery"],
    queryFn: () => {
      return apiAxiosInstance.get(`/admin/roles`).then((res) => res.data);
    },
  });
};

// get permission levels list
export const useGetPermissionsListQuery = () => {
  return useQuery({
    queryKey: ["getPermissionsListQuery"],
    queryFn: () => {
      return clientPortalAxiosInstance
        .get(`/User-Profile/clientAcccount/permissionsList`)
        .then((res) => res.data);
    },
  });
};

//get dashboard access list
export const useGetDashboardAccessListQuery = () => {
  return useQuery({
    queryKey: ["getDashboardAccessListQuery"],
    queryFn: () => {
      return clientPortalAxiosInstance
        .get(`/User-Profile/clientAcccount/dashboardAccessList`)
        .then((res) => res.data);
    },
  });
};

export const useGetClientCodeListQuery = () => {
  return useQuery({
    queryKey: ["getClientCodeListQuery"],
    queryFn: () => {
      return adminAxiosInstance.get(`/ClientCodeList`).then((res) => res.data);
    },
  });
};

export const useGetAccountAdminListQuery = () => {
  return useQuery({
    queryKey: ["getgetAccountAdminListQuery"],
    queryFn: () => {
      return adminAxiosInstance
        .get(`/getAccountAdminList`)
        .then((res) => res.data);
    },
  });
};

/** Client Specific Reports and Resources Start */
// api - get all resource/reports types dropdown list
export const useGetAllClientResourceTypesListQuery = () => {
  return useQuery({
    queryKey: ["getAllClientResourceTypes"],
    queryFn: () => {
      return clientPortalAxiosInstance
        .get(`/Reports-Resources/report/getAllClientResourceTypes`)
        .then((res) => res.data);
    },
  });
};

// Reports-Resources/report/getAllReportResourceScope

export const useGetAllReportResourceScopeListQuery = () => {
  return useQuery({
    queryKey: ["getAllReportResourceScope"],
    queryFn: () => {
      return clientPortalAxiosInstance
        .get(`/Reports-Resources/report/getAllReportResourceScope`)
        .then((res) => res.data);
    },
  });
};

/**this get call internally looks for emailId from token_claims by using passed token and return userDetails by email */
export const useGetLoggedInUserDetailsQuery = () => {
  return useQuery({
    queryKey: ["getLoggedInUserDetailsQuery"],
    queryFn: () => {
      return adminAxiosInstance.get(`/UserDetail`).then((res) => {
        return res.data;
      });
    },
    // enabled: !!isAuthenticated,
  });
};
/**this is User aka admin user from phase-1 */
export const useGetUserDetailsFromPhase1ByIdQuery = ({ id }) => {
  return useQuery({
    queryKey: ["getUserDetailsFromPhase1ByIdQuery", `${id}`],
    queryFn: () => {
      return adminAxiosInstance.get(`/UserDetailsById/${id}`).then((res) => {
        return res.data;
      });
    },
    // The query will not execute until the id exists
    // enabled: !!id,
  });
};

/** getting list of client accounts and sub acc based on role (right now used for A4 role)*/
export const useGetAccountSubAccountListOnlyForA4RoleQuery = ({ userId }) => {
  return useQuery({
    queryKey: ["getAccountSubAccountListOnlyForA4RoleQuery", userId],
    queryFn: () => {
      return apiAxiosInstance
        .get(
          `client-portal/User-Profile/client/getAccountSubAccountListOnlyForA4Role/${userId}`
        )
        .then((res) => res.data);
    },
    // The query will not execute until the id exists
    enabled: !!userId,
  });
};

/** !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */

/** All Mutations */
export const useGetServiceOfficeListMutation = () => {
  return useMutation({
    mutationFn: () => {
      return adminAxiosInstance.post(`/getServiceOfficeListByClientCodes`);
    },
  });
};

export const useSendEmailNotiMutation = () => {
  return useMutation({
    mutationFn: ({ body }) => {
      /**body should be array of Emails object
       * e.g. [
       * {
       *  Email:'abc@g.com'
       * },
       * ]
       */
      return clientPortalAxiosInstance.post(
        `/User-Profile/client/sendEmail`,
        body
      );
    },
  });
};

export const useActivateUserProfileMutation = () => {
  return useMutation({
    mutationFn: ({ body }) => {
      /**body should be array of string ids
       * e.g. ["weqwe3424234234", "sdfsdf3423423424"]
       */
      return clientPortalAxiosInstance.put(
        `User-Profile/client/activateProfile`,
        body
      );
    },
  });
};

export const useUpdateLastLoginDateMutation = () => {
  return useMutation({
    mutationFn: ({ lastLoginDate, clientUserId }) => {
      /**body should be array of string ids
       * e.g. ["weqwe3424234234", "sdfsdf3423423424"]
       */
      return clientPortalAxiosInstance.put(
        `User-Profile/client/lastProfileLogin/${clientUserId}`,
        {
          LastLogin: lastLoginDate,
        }
      );
    },
  });
};

export const useFileDownloadMutation = () => {
  return useMutation({
    mutationFn: ({ fileGUID, DownloadType, Extension }) => {
      return clientPortalAxiosInstanceForFileDownLoad
        .post(`/client-referral/referral/details/DownloadFileData`, {
          fileGUID,
          DownloadType /** "profileImage"|"logo"|"reportAndResources"|"programDescripitor" */,
          Extension /**pass extention without . e.g. "png"/"jpg" */,
        })
        .then((res) => {
          let contentTypeHeader = res.headers["content-type"];

          /**converting binary file to blob here */
          var blob = new Blob([res.data], {
            type: contentTypeHeader?.toLowerCase(),
            charset: "UTF-8",
          });
          return blob;
        });
    },
  });
};

export const useTrackActivityMutation = () => {
  return useMutation({
    mutationFn: ({ Type, CreatedBy, ItemId, Value }) => {
      /**body should be Object
       * e.g. { Type, CreatedBy, ItemId, Value }
       */
      return clientPortalAxiosInstance.post(
        `/client-notification/notification/addactivity`,
        { Type, CreatedBy, ItemId, Value }
      );
    },
  });
};
export const useTrackActivityFromPhaseOneAPIMutation = () => {
  return useMutation({
    mutationFn: ({
      StaffId,
      SourceId,
      Type,
      Value,
      TriggeredTimeStamp,
      CreatedTimeStamp,
      CreatedBy,
      UpdatedTimeStamp,
      UpdatedBy,
    }) => {
      /**body should be Object
       * e.g. { StaffId, SourceId, Type, Value, TriggeredTimeStamp, CreatedTimeStamp, CreatedBy, UpdatedTimeStamp, UpdatedBy }
       */
      return apiAxiosInstance.post(`/admin/Activities`, {
        StaffId,
        SourceId,
        Type,
        Value,
        TriggeredTimeStamp,
        CreatedTimeStamp,
        CreatedBy,
        UpdatedTimeStamp,
        UpdatedBy,
      });
    },
  });
};

//api for get sitecore content
export const useGetSiteCoreCMSData = (body) => {
  let genericData = { categoryname: "Default", language: "en-US" };
  let requestBody = { ...body, ...genericData };
  return useQuery({
    queryKey: ["getSiteCoreCMSData"],
    queryFn: () => {
      return sitecoreAxiosInstance
        .post(environment.ADMIN_PAGE_DETAILS, requestBody)
        .then((res) => {
          return res.data;
        });
    },
  });
};
